import React, { useState } from 'react';
import PropTypes from 'prop-types';

import clsx from 'clsx';
import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Redirect, useRouteMatch } from 'react-router-dom';

import Progress from 'components/Progress';
import Image from 'components/Image';

import appContent from 'helpers/appContent';

const TrainingCard = ({ chapter, chapterImage, chapterItemCount, chapterTitle, index, percentage, locked }) => {
  const { url } = useRouteMatch();

  const [redirect, setRedirect] = useState(null);
  const [loading, setLoading] = useState(false);

  const redir = () => setRedirect([url, chapter, 0].join('/'));

  let buttonText;
  if (url.includes('discover')) {
    buttonText = i18n.translate('trainingScreens.review');
  } else {
    buttonText = i18n.translate('trainingScreens.start');
  }

  return (
    <div
      role="button"
      tabIndex={index}
      onKeyPress={redir}
      onClick={redir}
      className={clsx('trainingCard', { loading, locked })}
    >
      <div className={clsx('experience', { incomplete: percentage < 100 })}>
        <span>{`${percentage}%`}</span>
      </div>
      <div className="textContainer">
        {!loading && (
          <div>
            <h3>{chapterTitle}</h3>
            {!locked && (
              <p className="duration">
                <FontAwesomeIcon icon={['far', 'clock']} />{' '}
                {i18n.translate('trainingScreens.durationInMinutes', {
                  number: chapterItemCount,
                })}
              </p>
            )}
            {!locked && (
              <button type="button" onClick={redir}>
                {buttonText}
              </button>
            )}
            {url.includes('retain') && locked && (
              <p>{i18n.translate('trainingScreens.unlock', { number: index + 1 })}</p>
            )}
            {!url.includes('retain') && locked && <p>{i18n.translate('trainingScreens.unlock', { number: index })}</p>}
          </div>
        )}
      </div>
      <div className="imageContainer">
        <Image src={appContent(chapterImage)} alt={chapterTitle} load={() => setLoading(false)} gradient />

        {!loading && locked && (
          <div className="overlay">
            <FontAwesomeIcon icon={['fas', 'lock']} />
          </div>
        )}

        {!loading && (
          <React.Fragment>
            <span className="chapterNumber">{`0${index + 1}`.slice(-2)}</span>
            <span className="chapterComplete">
              {percentage === 100 && !locked && (
                <FontAwesomeIcon icon={['far', 'check-circle']} className="chapterComplete" />
              )}
            </span>
          </React.Fragment>
        )}
      </div>

      {!loading && !locked && <Progress id={index} value={percentage} />}
      {redirect !== null && <Redirect push to={redirect} />}
    </div>
  );
};

export default TrainingCard;

TrainingCard.propTypes = {
  chapter: PropTypes.string,
  chapterImage: PropTypes.string,
  chapterItemCount: PropTypes.number,
  chapterTitle: PropTypes.string,
  index: PropTypes.number,
  percentage: PropTypes.number,
  locked: PropTypes.bool,
};

TrainingCard.defaultProps = {
  chapter: null,
  chapterImage: null,
  chapterItemCount: 0,
  chapterTitle: null,
  index: 0,
  percentage: 0,
  locked: false,
};
